'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDestinationImages = function () {
    function WinresDestinationImages($scope, $timeout, $uibModal, $document) {
        _classCallCheck(this, WinresDestinationImages);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.index = 0;
        this.active = parseInt(this.initialIndex, 10) || 0;
        this.$uibModal = $uibModal;
        this.$document = $document;
    }

    _createClass(WinresDestinationImages, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getOwnerData()

            this.data = this.winresReservationContext.getContext();

            this.$scope.interval = this.interval;

            if (this.useOwnerData === 'true') {
                this.winresReservationContext.getOwnerData().then(function (data) {
                    _this.ownerImages = data.Images;
                    _this.slides = [];
                    var i = 0;
                    _.each(_this.ownerImages, function (slide) {
                        _this.slides.push({
                            'image': slide.Url,
                            'id': i++
                        });
                    });
                });
            } else {
                this.$scope.$watch('$ctrl.data.Destination.Images', function () {
                    _this.initCarousel();
                });
            }
        }
    }, {
        key: 'initCarousel',
        value: function initCarousel() {
            var _this2 = this;

            this.slides = [];
            if (!this.data.Destination) {
                return;
            }
            var i = 0;
            this.data.Destination.Images.forEach(function (image) {
                _this2.slides.push({
                    image: image,
                    id: i++
                });
            });

            if (this.active > this.slides.length - 1) {
                this.active = this.slides.length - 1;
            }
        }
    }, {
        key: 'setSlide',
        value: function setSlide(idx) {
            this.active = idx;
        }
    }, {
        key: 'openGalleryModal',
        value: function openGalleryModal() {
            var _this3 = this;

            console.log("openGalleryModal()");
            if (this.noGalleryModal == "true") {
                return;
            }

            // Create web component element to apply web component styles.
            var winresWebComponent = document.createElement('div');
            winresWebComponent.className = 'winres-web-component';
            document.body.appendChild(winresWebComponent);

            var modalInstance = this.$uibModal.open({
                component: 'winresDestinationImagesModal',
                template: require('./winresDestinationImagesModal.html'),
                // using a inline controller and trick to get the close button working. https://stackoverflow.com/questions/22849061/angular-ui-modal-inline-template-and-controller
                // controller have to use using explicit annotation
                controller: ['$scope', function ($scope) {
                    $scope.closeModal = function () {
                        modalInstance.dismiss();
                    };
                }],
                size: 'lg',

                appendTo: angular.element(winresWebComponent),

                resolve: {
                    slides: function slides() {
                        return _this3.slides;
                    },
                    active: function active() {
                        return _this3.active;
                    },
                    fullScreen: function fullScreen() {
                        return _this3.fullScreen;
                    }
                },

                backdropClass: 'transparent-modal-backdrop',
                windowClass: this.fullScreen === 'true' ? 'image-carousel-modal-fullscreen' : 'image-carousel-modal'
            });

            modalInstance.closed.then(function () {
                document.body.removeChild(winresWebComponent);
            });
        }
    }]);

    return WinresDestinationImages;
}();

WinresDestinationImages.$inject = ['$scope', '$timeout', '$uibModal', '$document'];

_module3.default.component('winresDestinationImages', {
    template: require('./winresDestinationImages.html'),
    controller: WinresDestinationImages,
    bindings: {
        // Current image index
        initialIndex: '@',

        // If true, the image will be placed as div's background, default: false
        photoInBg: '@',

        // Image change interval. In milliseconds
        interval: '@',

        // Gets the owner data
        useOwnerData: '@',

        // Disable the opening of the gallery modal (lightbox) when clicking on image
        noGalleryModal: '@',

        // Show only the button and modal
        modalOnly: '@',

        // Full screen modal. true/false. default: false.
        fullScreen: '@'

    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});

_module3.default.component('winresDestinationImagesModal', {
    template: require('./winresDestinationImagesModal.html'),
    bindings: {
        modalInstance: '<',
        resolve: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationImages/winresDestinationImages.js
// module id = 422
// module chunks = 2